import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportSummaryStockPage } from './report-summary-stock.page';

const routes: Routes = [
  {
    path: '',
    component: ReportSummaryStockPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportSummaryStockPageRoutingModule {}
